import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngxs/store';
import { ConfirmUpdatedTerms, TermsType, UpdatedTermsState } from '@platform-frontend/account';
import { YATTA_PRIVACY_POLICY_URL, YATTA_TERMS_OF_SERVICE_URL } from '@platform-frontend/platform';
import { CountdownPageDirective } from '@platform-frontend/ui-tools';
import { CloseWindow, YattaExternalLanguageSpecificLinkUrl } from '@platform-frontend/util';
import { map, Observable, switchMap } from 'rxjs';
import { ACCOUNT_UI_TRANSLOCO_SCOPE } from '../account-ui-transloco-scope';

@UntilDestroy()
@Component({
  selector: 'yat-new-terms-ui',
  templateUrl: './new-terms-ui.component.html',
  styleUrls: ['./new-terms-ui.component.scss'],
  providers: [provideTranslocoScope(ACCOUNT_UI_TRANSLOCO_SCOPE)]
})
export class NewTermsUiComponent extends CountdownPageDirective implements OnInit {
  constructor(ngZone: NgZone, ref: ChangeDetectorRef, private store: Store) {
    super(ngZone, ref);
  }

  TERMS_OF_SERVICE_URL: YattaExternalLanguageSpecificLinkUrl;
  PRIVACY_POLICY_URL: YattaExternalLanguageSpecificLinkUrl;

  termsMode$: Observable<'TERMS' | 'PRIVACY' | 'TERMS_AND_PRIVACY'>;

  ngOnInit(): void {
    this.TERMS_OF_SERVICE_URL = YATTA_TERMS_OF_SERVICE_URL;
    this.PRIVACY_POLICY_URL = YATTA_PRIVACY_POLICY_URL;
    this.termsMode$ = this.store.select(UpdatedTermsState.platformTermsUpdatesTypes).pipe(map(types => this.mapTermsTypesToMode(types)));
    this.startCountdown();
  }

  private mapTermsTypesToMode(types: TermsType[]): 'TERMS' | 'PRIVACY' | 'TERMS_AND_PRIVACY' {
    if (types.includes('TERMS_AND_CONDITIONS') && types.includes('PRIVACY_STATEMENT')) {
      return 'TERMS_AND_PRIVACY';
    } else if (types.includes('PRIVACY_STATEMENT')) {
      return 'PRIVACY';
    } else {
      return 'TERMS';
    }
  }

  close(): void {
    this.store
      .dispatch(new ConfirmUpdatedTerms(this.store.selectSnapshot(UpdatedTermsState.platformTermsUpdatesTypes)))
      .pipe(
        switchMap(() => this.store.dispatch(new CloseWindow())),
        untilDestroyed(this)
      )
      .subscribe();
  }
}
